<template>
  <v-dialog
    v-model="modal"
    max-width="750">
    <template v-slot:default="dialog">
      <v-card
        class="rounded-lg">
        <v-toolbar
          width="100%"
          color="primary"
          height="79"
          style="position: relative;">
          <v-row
            class="text-center d-flex justify-center">
            <span
              class="text-h5 foreground-accent--text font-weight-bold">
              {{ title }}
            </span>
            <v-btn
              icon
              class="elevation-4"
              color="primary"
              heiht="43"
              max-height="43"
              width="43"
              style="position: absolute; right: 5%; top: 20%;"
              @click="close">
              <v-icon
                size="30"
                color="foreground-accent">
                close
              </v-icon>
            </v-btn>
          </v-row>
        </v-toolbar>
        <v-card-text
          class="mt-1 pb-0"
          style="height: 250px;">
          <v-container
            fuild
            class="fill-height pb-0">
            <v-row>
              <v-col
                cols="12"
                class="text-center">
                <span
                  class="text-h6 foreground--text font-weight-regular">
                  {{ description }}
                </span>
              </v-col>
              <v-col
                cols="12">
                <v-form
                  ref="ConfirmCommentModalForm">
                  <v-textarea
                    id="textAreaInvoiceModal"
                    placeholder="Digite aqui..."
                    v-model="comment"
                    outlined
                    hide-details
                    :rules="[rule.required]">
                    <template
                      v-slot:label>
                      <span
                        class="foreground--text text-h6">
                        Comentário
                      </span>
                    </template>
                  </v-textarea>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions
          class="px-13 pb-8 pt-7">
          <v-row>
            <v-spacer />
            <v-btn
              height="50"
              width="150"
              color="muted-foreground"
              class="rounded-pill mr-6"
              @click="close">
              <v-icon
                color="primary">
                mdi mdi-arrow-left
              </v-icon>
              <span
                class="primary--text text-h6">
                Voltar
              </span>
            </v-btn>
            <v-btn
              height="50"
              width="260"
              color="primary"
              class="rounded-pill"
              @click="confirm">
              <span
                class="foreground-accent--text text-h6">
                {{ confirmLabel }}
              </span>
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import Rules from '@/shared/validators/formRules';
export default {
  name: "ConfirmationModal",

  data: () => ({
    modal: false,
    dataId: null,
    comment: null,
    rule: null,
  }),

  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar'
    },
  },

  methods: {
    open(dataId) {
      this.modal = true;
      this.dataId = dataId;
    },
    close() {
      this.dataId = null;
      this.comment = null;
      this.modal = false;
    },
    confirm() {
      if (!this.$refs.ConfirmCommentModalForm.validate()) return
      this.$emit('confirm', {
        dataId: this.dataId,
        comment: this.comment
      })
      this.close();
		},
  },

  created() {
    this.rule = new Rules();
  },
}
</script>